(function () {
  var selector = '[data-za-announcement-carousel]';
  var defaultInterval = 4200;
  var transitionBuffer = 460;

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function nextFrame(callback) {
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(callback);
      return;
    }

    window.setTimeout(callback, 16);
  }

  function initCarousel(carousel) {
    if (!carousel || carousel.getAttribute('data-za-announcement-ready') === 'true') return;

    var slides = toArray(carousel.querySelectorAll('[data-za-announcement-slide]'));
    if (slides.length < 2) return;

    var prev = carousel.querySelector('[data-za-announcement-prev]');
    var next = carousel.querySelector('[data-za-announcement-next]');
    var configuredInterval = parseInt(carousel.getAttribute('data-za-announcement-interval') || '', 10);
    var interval = isNaN(configuredInterval) || configuredInterval < 2400 ? defaultInterval : configuredInterval;
    var index = -1;
    var timer = 0;
    var isFocused = false;

    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i].classList.contains('is-active')) {
        index = i;
        break;
      }
    }

    index = index >= 0 ? index : 0;
    carousel.setAttribute('data-za-announcement-ready', 'true');

    function clearTimer() {
      window.clearTimeout(timer);
      timer = 0;
    }

    function shouldHold() {
      return isFocused || document.hidden === true;
    }

    function setHiddenState() {
      slides.forEach(function (slide, slideIndex) {
        slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
      });
    }

    function schedule() {
      clearTimer();
      if (shouldHold()) return;
      timer = window.setTimeout(function () {
        show(index + 1, 1);
      }, interval);
    }

    function show(targetIndex, direction) {
      var nextIndex = ((targetIndex % slides.length) + slides.length) % slides.length;
      if (nextIndex === index) {
        schedule();
        return;
      }

      var outgoing = slides[index];
      var incoming = slides[nextIndex];
      var incomingClass = direction < 0 ? 'is-prev' : 'is-next';
      var leavingClass = direction < 0 ? 'is-leaving-prev' : 'is-leaving-next';

      slides.forEach(function (slide) {
        slide.classList.remove('is-prev', 'is-next', 'is-leaving-prev', 'is-leaving-next');
      });

      incoming.classList.add(incomingClass);

      nextFrame(function () {
        outgoing.classList.remove('is-active');
        outgoing.classList.add(leavingClass);
        incoming.classList.add('is-active');
        incoming.classList.remove(incomingClass);
        index = nextIndex;
        setHiddenState();
        schedule();
      });

      window.setTimeout(function () {
        outgoing.classList.remove('is-leaving-prev', 'is-leaving-next');
      }, transitionBuffer);
    }

    if (prev) {
      prev.addEventListener('click', function () {
        show(index - 1, -1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        show(index + 1, 1);
      });
    }

    carousel.addEventListener('focusin', function () {
      isFocused = true;
      clearTimer();
    });

    carousel.addEventListener('focusout', function () {
      nextFrame(function () {
        if (carousel.contains(document.activeElement)) return;
        isFocused = false;
        schedule();
      });
    });

    document.addEventListener('visibilitychange', schedule);
    window.addEventListener('pageshow', schedule);

    setHiddenState();
    schedule();
  }

  function initAll() {
    toArray(document.querySelectorAll(selector)).forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('load', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
